import { render, staticRenderFns } from "./ServiceCreditHistory.vue?vue&type=template&id=573231d0&scoped=true"
import script from "./ServiceCreditHistory.vue?vue&type=script&lang=js"
export * from "./ServiceCreditHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573231d0",
  null
  
)

export default component.exports